<template>
  <div>
    <div class="flex-grow" id="popup-content-amount-not-enough">
      <p
        class="text-grey-2 mb-10 mt-6 md:mt-0 text-xl font-medium text-center"
        v-html="$t('onboarding.is_ubo.title',{name: storeData.legal_rep.name})"
      />
      <p
        class="text-sm text-grey-3"
        v-html="$t('onboarding.is_ubo.description',{name: storeData.legal_rep.name, org: storeData.company_name})"
      />
      <div class="flex mt-10 gap-4">
        <GpButton @click="next(false)" type="submit" color="white">
          {{ $t('wording.no') }}
        </GpButton>
        <GpButton @click="next(true)" type="submit">
          {{ $t('wording.yes') }}
        </GpButton>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import GpButton from '@/components/general/GpButton.vue'
import { computed } from "vue";

export default {
  components: {
    GpButton
  },
  props: {},
  setup() {
    const store = useStore()
    const storeData = computed(() => {
      return store.state.onboarding.data
    })
    async function next(value) {
      store.dispatch('setIsUbo', value)
      store.dispatch('setShowPopup', false)
    }

    return { next, storeData }
  }
}
</script>
